var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeatherData1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 284 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-2,.cls-3{stroke:#010101;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{stroke-dasharray:3.1 5.43;}.cls-4{stroke:#413e56;}.cls-5{fill:#418782;}.cls-6{fill:#fff;stroke:#418782;fill-rule:evenodd;}.cls-7{fill:#0f6963;fill-opacity:0.2;}.cls-8{fill:#403e56;}.cls-9{clip-path:url(#clip-path);}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:#4ab382;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.2,95.6A18.07,18.07,0,0,0,99,104.42s1.25-7.36-1.24-13.53A18.07,18.07,0,0,0,90,82.07S88.71,89.43,91.2,95.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.3,94.18c4.7,3.45,6.51,10.3,6.51,10.3S93,105.74,88.3,102.29,81.78,92,81.78,92,87.6,90.73,92.3,94.18Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_weather-data_1.2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rain"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.2,38.09H214A19.87,19.87,0,0,1,213,32c0-9.88,7.24-17.89,16.16-17.89,7.09,0,13.11,5.06,15.28,12.1a12.11,12.11,0,0,1,5.68-1.39,11.66,11.66,0,0,1,10.92,7.09,10.82,10.82,0,0,1,2.45-.27C268.17,31.6,272,34.47,272.2,38.09Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 260.12,
    y1: 57.97,
    x2: 261.01,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 263.44,
    y1: 51.32,
    x2: 266.04,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.25,
    y1: 43.7,
    x2: 268.15,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 254.43,
    y1: 57.97,
    x2: 255.33,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 257.75,
    y1: 51.32,
    x2: 260.35,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 261.57,
    y1: 43.7,
    x2: 262.46,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 248.75,
    y1: 57.97,
    x2: 249.65,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 252.07,
    y1: 51.32,
    x2: 254.67,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.88,
    y1: 43.7,
    x2: 256.78,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 243.07,
    y1: 57.97,
    x2: 243.96,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 246.39,
    y1: 51.32,
    x2: 248.99,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 250.2,
    y1: 43.7,
    x2: 251.1,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.38,
    y1: 57.97,
    x2: 238.28,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.7,
    y1: 51.32,
    x2: 243.3,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 244.52,
    y1: 43.7,
    x2: 245.41,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.7,
    y1: 57.97,
    x2: 232.59,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 235.02,
    y1: 51.32,
    x2: 237.62,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 238.83,
    y1: 43.7,
    x2: 239.73,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 226.02,
    y1: 57.97,
    x2: 226.91,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 229.34,
    y1: 51.32,
    x2: 231.94,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 233.15,
    y1: 43.7,
    x2: 234.04,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 220.33,
    y1: 57.97,
    x2: 221.23,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 223.65,
    y1: 51.32,
    x2: 226.25,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 227.47,
    y1: 43.7,
    x2: 228.36,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 214.65,
    y1: 57.97,
    x2: 215.54,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217.97,
    y1: 51.32,
    x2: 220.57,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.78,
    y1: 43.7,
    x2: 222.68,
    y2: 41.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.97,
    y1: 57.97,
    x2: 209.86,
    y2: 56.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.29,
    y1: 51.32,
    x2: 214.89,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 216.1,
    y1: 43.7,
    x2: 216.99,
    y2: 41.91
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "wind"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.42,106a5.56,5.56,0,1,1,5.56,5.56H232.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.25,126a10.54,10.54,0,1,0,10.53-10.54H225.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.83,127.15a7,7,0,1,0,7-7H227.08"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "temp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.78,123.35a9.83,9.83,0,1,0,13.71-9V90a3.88,3.88,0,1,0-7.76,0v24.34A9.82,9.82,0,0,0,28.78,123.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.65,
    cy: 122.86,
    r: 2.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.55,
    y1: 106.47,
    x2: 38.55,
    y2: 119.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.97,
    y1: 100.39,
    x2: 11.28,
    y2: 100.39
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "12.2 103.32 14 101.82 15.8 100.32 14 98.82 12.2 97.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "26.47 97.44 24.66 98.94 22.86 100.44 24.66 101.94 26.47 103.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.59,
    y1: 92.04,
    x2: 19.59,
    y2: 108.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "16.59 93.05 18.09 94.85 19.59 96.65 21.09 94.85 22.59 93.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "22.59 107.21 21.09 105.41 19.59 103.61 18.09 105.41 16.59 107.21"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "arrows"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "57.76 60.61 80.59 129.34 135.85 129.34 135.85 115.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "55.71 127.32 74.98 136.42 139.84 136.42 139.84 114.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "229.59 63.76 195.09 133.51 148.41 133.51 148.41 113.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "219.67 118.52 203.23 138.85 144.33 138.85 144.33 117.27"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "color-2",
    className: "cls-5",
    points: "101.39 46.65 141.34 16.88 181.28 46.65 181.28 106.18 101.39 106.18 101.39 46.65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "house_window_large",
    "data-name": "house/window/large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9",
    className: "cls-6",
    d: "M170.3,90.89v6.67h-5.88V90.89Zm-6.27,0v6.67h-5.88V90.89Zm0-7.06V90.5h-5.88V83.83Zm6.27,0V90.5h-5.88V83.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow_center",
    "data-name": "shadow center",
    className: "cls-7",
    points: "158.15 83.83 158.15 97.56 160.85 97.56 160.85 85.79 170.3 84.81 170.3 83.83 158.15 83.83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "house_window_large-2",
    "data-name": "house/window/large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9-2",
    "data-name": "Rectangle-Copy-9",
    className: "cls-6",
    d: "M125.87,90.89v6.67H120V90.89Zm-6.28,0v6.67h-5.88V90.89Zm0-7.06V90.5h-5.88V83.83Zm6.28,0V90.5H120V83.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow_center-2",
    "data-name": "shadow center",
    className: "cls-7",
    points: "113.71 83.83 113.71 97.56 116.41 97.56 116.41 85.79 125.87 84.81 125.87 83.83 113.71 83.83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "house_window_large-3",
    "data-name": "house/window/large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9-3",
    "data-name": "Rectangle-Copy-9",
    className: "cls-6",
    d: "M148.08,90.89v6.67H142.2V90.89Zm-6.27,0v6.67h-5.88V90.89Zm0-7.06V90.5h-5.88V83.83Zm6.27,0V90.5H142.2V83.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow_center-3",
    "data-name": "shadow center",
    className: "cls-7",
    points: "135.93 83.83 135.93 97.56 138.63 97.56 138.63 85.79 148.08 84.81 148.08 83.83 135.93 83.83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "house_window_large-4",
    "data-name": "house/window/large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9-4",
    "data-name": "Rectangle-Copy-9",
    className: "cls-6",
    d: "M170.3,62.66v6.67h-5.88V62.66Zm-6.27,0v6.67h-5.88V62.66Zm0-7.06v6.67h-5.88V55.6Zm6.27,0v6.67h-5.88V55.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow_center-4",
    "data-name": "shadow center",
    className: "cls-7",
    points: "158.15 55.6 158.15 69.33 160.85 69.33 160.85 57.56 170.3 56.58 170.3 55.6 158.15 55.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "house_window_large-5",
    "data-name": "house/window/large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9-5",
    "data-name": "Rectangle-Copy-9",
    className: "cls-6",
    d: "M125.87,62.66v6.67H120V62.66Zm-6.28,0v6.67h-5.88V62.66Zm0-7.06v6.67h-5.88V55.6Zm6.28,0v6.67H120V55.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow_center-5",
    "data-name": "shadow center",
    className: "cls-7",
    points: "113.71 55.6 113.71 69.33 116.41 69.33 116.41 57.56 125.87 56.58 125.87 55.6 113.71 55.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "house_window_large-6",
    "data-name": "house/window/large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9-6",
    "data-name": "Rectangle-Copy-9",
    className: "cls-6",
    d: "M148.08,62.66v6.67H142.2V62.66Zm-6.27,0v6.67h-5.88V62.66Zm0-7.06v6.67h-5.88V55.6Zm6.27,0v6.67H142.2V55.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow_center-6",
    "data-name": "shadow center",
    className: "cls-7",
    points: "135.93 55.6 135.93 69.33 138.63 69.33 138.63 57.56 148.08 56.58 148.08 55.6 135.93 55.6"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "shadow_center-7",
    "data-name": "shadow center",
    className: "cls-7",
    points: "141.34 16.88 181.28 47.01 181.28 106.18 156.85 106.18 156.85 56.57 130.3 25.1 141.34 16.88"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ground"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-8",
    d: "M194.22,107.29c-5.36-1-13.82-1.84-18.76-2.53l1.91-4.5c-.66-.26-3.52,2.34-3.52,2.34V99c-3.31.53-2.43,4.43-2.43,4.43L167.68,99l1.84,5a287.69,287.69,0,0,0-39.12-2.33L132,97.78c-.66-.26-3.52,2.35-3.52,2.35V94.29c-3.31.52-2.43,6.62-2.43,6.62l-3.74-4.43,2,5.31a186.14,186.14,0,0,0-22.45,2.14c1.62-6,7.3-11.75,7.3-11.75a13.17,13.17,0,0,0-7.7,6.77V83.83q-4.18,2.23-2.87,17.86l.17,2.78a78,78,0,0,0-11.5,2.82q0,1.63,60.35,1.64Q193.75,108.93,194.22,107.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 88.04,
    y: 80.11,
    width: 12.85,
    height: 26.27
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 80.18,
    y: 89.81,
    width: 20.24,
    height: 16.86
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.89,
    y1: 43.3,
    x2: 40.83,
    y2: 53.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 51.51,
    y1: 43.08,
    x2: 54.84,
    y2: 52.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.55,
    y1: 38.43,
    x2: 66,
    y2: 44.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.69,
    y1: 31.12,
    x2: 70.04,
    y2: 30.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.13,
    y1: 23.94,
    x2: 65.42,
    y2: 17.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.84,
    y1: 19.64,
    x2: 53.91,
    y2: 9.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.22,
    y1: 19.85,
    x2: 39.89,
    y2: 10.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.19,
    y1: 24.51,
    x2: 28.73,
    y2: 18.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.04,
    y1: 31.82,
    x2: 24.69,
    y2: 31.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.6,
    y1: 39,
    x2: 29.31,
    y2: 45.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 47.71,
    cy: 31.53,
    r: 6.39
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherData1);
export default __webpack_public_path__ + "static/media/icon_weather-data_1.221455a00d0e9ba20aca4fc8904109b3.svg";
export { ForwardRef as ReactComponent };